// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"no_access_banner_wrapper__OR1ux","title":"no_access_banner_title__CSfwT","subtitle":"no_access_banner_subtitle__852fH"};